import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { map, take } from "rxjs/operators";
import { UserService } from "@career/core/services/user.service";
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class NotAuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private userSvc : UserService,
    private router: Router
  ) {}

  canActivate() {
    return forkJoin([this.userSvc.getUser(true).pipe(take(1)), this.userSvc.isAdmin().pipe(take(1))]).pipe(
      map(([user, isAdmin]) => {
        if (user === null) {
          return true;
        } else if (isAdmin) {
          this.router.navigate(["/admin/pageConfiguration"]);
        } else {
          this.router.navigate(["/"]);
        }
        return false;
      })
    );
  }
}
